/* ====== Sort UI (guarded) ====== */

function syncSortState() {
  const params = new URLSearchParams(window.location.search);
  const sortBy = params.get('sort_by') || 'manual';

  document.querySelectorAll('.sort-option').forEach(opt => {
    opt.classList.remove('selected-sort');
    const input = opt.querySelector('input[type="radio"]');
    if (!input) return;
    input.checked = false;

    if (input.dataset.sortValue === sortBy) {
      input.checked = true;
      opt.classList.add('selected-sort');
    }
  });
}

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.custom-sort-toggle');
  if (!toggle) return;

  const scope = toggle.closest('.custom-sort') || document;
  const optionsContainer =
    scope.querySelector('.custom-sort-options') ||
    document.querySelector('.custom-sort-options');

  if (optionsContainer) optionsContainer.classList.toggle('sort__collapse');
  toggle.classList.toggle('sort__collapse');
});

document.addEventListener('change', (e) => {
  const input = e.target.closest('.sort-option input[type="radio"]');
  if (!input) return;

  const sortValue = input.getAttribute('data-sort-value');
  const target = document.querySelector(`.popout-list__option[data-value="${sortValue}"]`);
  if (target) target.click();
});

// function syncSortRadioFromURL() {
//   const params = new URLSearchParams(window.location.search);
//   const sortBy = params.get('sort_by') || 'manual';
//   const selectedInput = document.querySelector(`.sort-option input[data-sort-value="${sortBy}"]`);
//   if (selectedInput) selectedInput.checked = true;
// }
// document.addEventListener('DOMContentLoaded', syncSortRadioFromURL);
document.addEventListener('DOMContentLoaded', syncSortState);



/* ====== Utils ====== */
const norm = s => (s || '').toLowerCase().trim()
  .replace(/[\s\/]+/g,'-')
  .replace(/-+/g,'-')
  .replace(/[^a-z0-9\-]/g,'');

function getSelectedColorsFromURL() {
  const p = new URLSearchParams(location.search);

  const fromFilter = p.getAll('filter.v.option.colour').map(norm);

  const q = (p.get('q') || '').toLowerCase();
  const tokens = q
    .replace(/[\+\%20]+/g,' ')
    .split(/[^\w\/-]+/)
    .map(norm)
    .filter(Boolean);

  const groups = getColorGroupsDict();
  const known = new Set(Object.keys(groups).map(norm));
  Object.values(groups).forEach(arr => arr.forEach(c => known.add(norm(c))));

  const fromQuery = tokens.filter(t => known.has(t));


  if (fromQuery.length === 0 && tokens.length) {
    const present = new Set();
    document.querySelectorAll('.color-media-map').forEach(el => {
      try {
        const map = JSON.parse(el.textContent);
        Object.keys(map).forEach(k => present.add(k));
      } catch(_) {}
    });
    tokens.forEach(t => { if (present.has(t)) fromQuery.push(t); });
  }

  return Array.from(new Set([...fromFilter, ...fromQuery]));
}


function getColorGroupsDict() {
  try {
    const el = document.getElementById('color-groups');
    return el ? JSON.parse(el.textContent) : {};
  } catch(e) { return {}; }
}

function expandSelectedColors(selected, groups) {
  const out = new Set(selected);
  selected.forEach(c => (groups[c] || []).forEach(alias => out.add(norm(alias))));
  return [...out];
}

function parseCardColorMap(card) {
  const el = card.querySelector('.color-media-map');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch(e) { return null; }
}

function ensureImg(node) {
  if (!node) return null;
  if (node.tagName === 'IMG') return node;
  const img = document.createElement('img');
  img.className = node.className;
  img.setAttribute('loading','lazy');
  if (node.parentNode) node.parentNode.replaceChild(img, node);
  return img;
}

function ensureDefaultCache(img) {
  if (!img || img.tagName !== 'IMG') return;
  if (!img.dataset.defaultSrc) {
    const ds = img.getAttribute('data-default-src');
    img.dataset.defaultSrc = ds || img.getAttribute('src') || '';
  }
}

function restoreDefault(img) {
  if (!img || img.tagName !== 'IMG') return;
  const ds = img.dataset.defaultSrc || img.getAttribute('data-default-src') || '';
  if (ds) img.src = ds;
  img.style.display = '';
}

function ensureDefaultHref(el) {
  if (el && !el.dataset.defaultHref) {
    el.dataset.defaultHref = el.getAttribute('href') || '';
  }
}
function restoreDefaultHref(el) {
  if (el && el.dataset.defaultHref) {
    el.setAttribute('href', el.dataset.defaultHref);
  }
}


const SELECTED_COLOUR_PREFIX = 'selected_colour--';

function setSelectedColourMarkings(card, colourKey) {
  const cardEl = card.closest('.product-card') || card;

  [...cardEl.classList].forEach(cls => {
    if (cls.startsWith(SELECTED_COLOUR_PREFIX)) cardEl.classList.remove(cls);
  });
  cardEl.classList.remove('selected--color-variant');
  if (colourKey) {
    cardEl.classList.add(SELECTED_COLOUR_PREFIX + colourKey, 'selected--color-variant');
  }

  const link = cardEl.querySelector('.product-media-link');
  if (link) {
    ensureDefaultHref(link);

    [...link.classList].forEach(cls => {
      if (cls.startsWith(SELECTED_COLOUR_PREFIX)) link.classList.remove(cls);
    });
    link.classList.remove('selected--color-variant');

    if (colourKey) {
      link.classList.add(SELECTED_COLOUR_PREFIX + colourKey, 'selected--color-variant');

      const swatch = cardEl.querySelector(`.product-swatches .product-swatch.color--${colourKey}`);
      if (swatch && swatch.href) {
        link.href = swatch.href;
      } else {
        restoreDefaultHref(link);
      }
    } else {
      restoreDefaultHref(link);
    }
  }

  const swatches = cardEl.querySelectorAll('.product-swatches .product-swatch');
  swatches.forEach(s => s.classList.remove('is-selected-swatch'));
  if (colourKey) {
    const match = cardEl.querySelector(`.product-swatches .product-swatch.color--${colourKey}`);
    if (match) match.classList.add('is-selected-swatch');
  }
}



function applySelectionToCard(card, expanded) {
  const map = parseCardColorMap(card);
  if (!map) return;

  let img1 = ensureImg(card.querySelector('.product-media--1')); // main
  let img2 = ensureImg(card.querySelector('.product-media--2')); // hover
  ensureDefaultCache(img1);
  ensureDefaultCache(img2);

  card.querySelectorAll('.product-variant-media').forEach(el => el.style.display = 'none');

  let chosen = null;
  let chosenKey = null;
  for (const c of expanded) {
    if (map[c]) { chosenKey = c; chosen = map[c]; break; }
  }

  if (chosen) {
    if (img1) { img1.src = chosen.primary; img1.style.display = ''; }
    if (img2) { img2.src = chosen.hover ? chosen.hover : chosen.primary; img2.style.display = ''; }
    setSelectedColourMarkings(card, chosenKey);
  } else {
    if (img1) restoreDefault(img1);
    if (img2) restoreDefault(img2);
    setSelectedColourMarkings(card, null);
  }
}

function applySelectionToGrid() {
  const selected = getSelectedColorsFromURL();
  const groups = getColorGroupsDict();
  const expanded = expandSelectedColors(selected, groups);
  document.querySelectorAll('.product-card').forEach(card => {
    applySelectionToCard(card, expanded);
  });
}


document.addEventListener('DOMContentLoaded', applySelectionToGrid);
window.addEventListener('popstate', applySelectionToGrid);

(function (history) {
  const orig = history.pushState;
  history.pushState = function() {
    const r = orig.apply(history, arguments);
    queueMicrotask(applySelectionToGrid);
    return r;
  };
})(window.history);

document.addEventListener('shopify:section:load', applySelectionToGrid);

document.addEventListener('click', (e) => {
  if (
    e.target.closest('.collection__active__filters-clear a') ||
    e.target.closest('.active__filters__remove')
  ) {
    setTimeout(applySelectionToGrid, 0);
  }
});

const productsRoot = document.querySelector('[data-products-grid]');
if (productsRoot) {
  const mo = new MutationObserver(() => {
    clearTimeout(productsRoot._cc_to);
    productsRoot._cc_to = setTimeout(applySelectionToGrid, 0);
  });
  mo.observe(productsRoot, { childList: true, subtree: true });
}

if (document.readyState !== 'loading') {
  applySelectionToGrid();
}


document.addEventListener('click', (e) => {
  const applyBtn = e.target.closest('.mobile_filters_apply');
  if (!applyBtn) return;

  const closeBtn = document.querySelector('.collection__filters__outer .drawer__close');
  if (closeBtn) closeBtn.click();
});
